<template>
  <img :src="logoUrl" :alt="alt" :class="['app-logo', className]" />
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

/** Theme-aware logo: uses theme store (single source). Assets: src/assets/brand/logo-full-light.png, logo-full-dark.png */
export default {
  name: 'AppLogo',
  props: {
    alt: { type: String, default: 'ResyMaid' },
    className: { type: String, default: '' },
  },
  setup() {
    const store = useStore();
    const logoUrl = computed(() => store.getters['theme/logoUrl']);
    return { logoUrl };
  },
};
</script>

<style scoped>
.app-logo {
  display: block;
  height: 80px;
  width: auto;
  object-fit: contain;
}
</style>
